import { render } from "./abstractDetails.vue?vue&type=template&id=6a8e9b54&scoped=true"
import script from "./abstractDetails.vue?vue&type=script&lang=js"
export * from "./abstractDetails.vue?vue&type=script&lang=js"

import "./abstractDetails.vue?vue&type=style&index=0&id=6a8e9b54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8e9b54"]])

export default __exports__